import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CatalogService } from './api/catalog.service';
import { CategoryService } from './api/category.service';
import { EventsSubscriptionService } from './api/eventsSubscription.service';
import { ExportJobService } from './api/exportJob.service';
import { ImportJobService } from './api/importJob.service';
import { NotificationListenersClientSideService } from './api/notificationListenersClientSide.service';
import { ProductOfferingService } from './api/productOffering.service';
import { ProductOfferingPriceService } from './api/productOfferingPrice.service';
import { ProductSpecificationService } from './api/productSpecification.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CatalogService,
    CategoryService,
    EventsSubscriptionService,
    ExportJobService,
    ImportJobService,
    NotificationListenersClientSideService,
    ProductOfferingService,
    ProductOfferingPriceService,
    ProductSpecificationService ]
})
export class ApiModule {
public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
